import {AppDomain} from '@/env/enums/Domains';

export interface ISimulationFiltersConfig {
  realEstateInsurance: boolean
  lifeInsurance: boolean
  acquireCreditCard: boolean
}

export const SimulationFiltersConfig: Record<keyof typeof AppDomain, ISimulationFiltersConfig> = {
  LENDI_PL: {
    realEstateInsurance: true,
    lifeInsurance: false,
    acquireCreditCard: true,
  },
  NESTO_RO: {
    realEstateInsurance: false,
    lifeInsurance: false,
    acquireCreditCard: false,
  },
};
